"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _urlLib = require("url-lib");

var _destinationUtils = require("@eb/destination-utils");

var _performanceMonitor = require("@eb/performance-monitor");

var _http = require("js-utils/http");

var _path = require("js-utils/path");

var _janus = require("js-utils/janus");

var _organizer = require("../api/organizer");

var _state = require("../utils/state");

var _modals = require("../utils/modals");

var _FollowButton = _interopRequireDefault(require("../components/FollowButton"));

var _FollowNotification = _interopRequireDefault(require("../components/FollowNotification"));

var _FollowCard = _interopRequireDefault(require("../components/FollowCard"));

var _FollowGDPRModal = _interopRequireDefault(require("../components/FollowGDPRModal"));

var _FollowLoginModal = _interopRequireDefault(require("../components/FollowLoginModal"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getLoggedOutOrganizerData = function getLoggedOutOrganizerData(organizerId) {
  var organizerData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, organizerData[organizerId]), {}, {
    followedByYou: false
  });
};

var hasRequiredOrganizerData = function hasRequiredOrganizerData(_ref) {
  var followedByYou = _ref.followedByYou,
      id = _ref.id,
      imageUrl = _ref.imageUrl,
      name = _ref.name,
      url = _ref.url;
  var hasValidFollowedByYou = typeof followedByYou === 'boolean';
  var hasValidId = typeof id === 'string';
  var hasValidImageURL = typeof imageUrl === 'string';
  var hasValidName = typeof name === 'string';
  var hasValidProfileURL = typeof url === 'string';
  return hasValidFollowedByYou && hasValidId && hasValidImageURL && hasValidName && hasValidProfileURL;
};

var hasAllData = function hasAllData(organizerData, organizers) {
  var hasValidOrganizerData = organizerData && !(0, _isEmpty.default)(organizerData);
  var hasDataForAllOrganizers = Object.keys(organizerData).length === organizers.length;

  if (!hasValidOrganizerData || !hasDataForAllOrganizers) {
    return false;
  }

  return Object.keys(organizerData).every(function (orgId) {
    return hasRequiredOrganizerData(organizerData[orgId]);
  });
};

var FollowMarionette = /*#__PURE__*/function (_Component) {
  _inherits(FollowMarionette, _Component);

  var _super = _createSuper(FollowMarionette);

  function FollowMarionette(props) {
    var _this;

    _classCallCheck(this, FollowMarionette);

    var _getFollowState = props.getFollowState,
        _setFollowState = props.setFollowState;
    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_handleFollowStateChange", function (_ref2) {
      var organizerData = _ref2.organizerData,
          organizers = _ref2.organizers;

      _this.setState({
        organizers: organizers,
        organizerData: organizerData
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnFollowOrganizer", function (organizerId) {
      var isAuthenticated = _this.props.isAuthenticated;

      if (isAuthenticated) {
        _this._followOrganizer(organizerId);
      } else {
        _this._trackFollowAttempt(organizerId);

        _this._handleLoggedOutFollow(organizerId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnUnfollowOrganizer", function (organizerId) {
      _this._unfollowOrganizer(organizerId);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleError", function (organizerId, action) {
      _this._renderNotification(organizerId, action);
    });

    _defineProperty(_assertThisInitialized(_this), "_followOrganizer", function (organizerId) {
      (0, _organizer.followOrganizer)(organizerId).catch(function () {
        return _this._handleError(organizerId, _constants.ERROR_FOLLOW);
      }).then(function (response) {
        _this._updateFollowState(organizerId, response);

        _this._trackFollowEvent(organizerId);

        _this._informUser(organizerId);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_unfollowOrganizer", function (organizerId) {
      (0, _organizer.unfollowOrganizer)(organizerId).catch(function () {
        return _this._handleError(organizerId, _constants.ERROR_UNFOLLOW);
      }).then(function (response) {
        _this._updateFollowState(organizerId, response);

        _this._trackUnfollowEvent(organizerId);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleLoggedOutFollow", function (organizerId) {
      var loginOptions = _this.props.loginOptions;
      var referrer = loginOptions.referrer || (0, _path.getUrlPath)();

      if (loginOptions.shouldUseSigninConfirmationRedirect) {
        _this._setUserActionCookie(organizerId, referrer);

        var url = (0, _urlLib.formatUrl)(_constants.LOGIN_CONFIRMATION_PATH, {
          referrer: referrer
        });

        if (loginOptions.shouldOpenNewTab) {
          return window.open(url);
        }

        return (0, _http.setWindowLocation)(url);
      }

      return _this._renderLoginModal(organizerId);
    });

    _defineProperty(_assertThisInitialized(_this), "_setUserActionCookie", function (organizerId, referrer) {
      var getFollowState = _this.props.getFollowState;

      var _getFollowState2 = getFollowState(),
          organizerData = _getFollowState2.organizerData;

      (0, _destinationUtils.setAction)({
        action: 'followOrganizer',
        origin: referrer,
        payload: {
          organizerId: organizerId,
          organizerName: (0, _get.default)(organizerData, [organizerId, 'name']),
          image: (0, _get.default)(organizerData, [organizerId, 'profileImage'])
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_hydrateOrganizerData", function () {
      var organizers = _this.state.organizers;
      var _this$props = _this.props,
          isAuthenticated = _this$props.isAuthenticated,
          organizerData = _this$props.organizerData;
      var isMultiOrganizer = organizers.length > 1;

      if (hasAllData(organizerData, organizers)) {
        organizers.forEach(function (organizerId) {
          _this._updateState(organizerId, organizerData[organizerId]);
        });
      } else if (isAuthenticated || isMultiOrganizer) {
        organizers.forEach(function (organizerId) {
          (0, _organizer.getOrganizer)(organizerId).catch(_this._handleError.bind(null, _constants.ERROR_ORG_INFO)).then(_this._updateState.bind(null, organizerId));
        });
      } else {
        organizers.forEach(function (organizerId) {
          _this._updateState(organizerId, getLoggedOutOrganizerData(organizerId, organizerData));
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_updateState", function (organizerId, _ref3) {
      var followedByYou = _ref3.followedByYou,
          name = _ref3.name,
          url = _ref3.url,
          _ref3$image = _ref3.image;
      _ref3$image = _ref3$image === void 0 ? {} : _ref3$image;
      var profilePicture = _ref3$image.url,
          numUpcomingEvents = _ref3.numUpcomingEvents,
          numFollowers = _ref3.numFollowers,
          imageUrl = _ref3.imageUrl;
      var _this$props2 = _this.props,
          getFollowState = _this$props2.getFollowState,
          setFollowState = _this$props2.setFollowState;

      if (_this._isMounted) {
        var currentState = getFollowState();
        setFollowState(_objectSpread(_objectSpread({}, currentState), {}, {
          organizerData: _objectSpread(_objectSpread({}, currentState.organizerData), {}, _defineProperty({}, organizerId, _objectSpread(_objectSpread({}, currentState.organizerData[organizerId]), {}, {
            id: organizerId,
            followedByYou: followedByYou,
            name: name,
            url: url,
            profilePicture: profilePicture || imageUrl,
            numUpcomingEvents: numUpcomingEvents,
            numFollowers: numFollowers
          })))
        }));

        _this._shouldFollowOrganizerFromCookie(organizerId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_informUser", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(organizerId) {
        var _this$props3, isGDPRCountry, userId, _this$props3$featureF, featureFlags, shouldShowModal;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this._renderNotification(organizerId);

                _this$props3 = _this.props, isGDPRCountry = _this$props3.isGDPRCountry, userId = _this$props3.userId, _this$props3$featureF = _this$props3.featureFlags, featureFlags = _this$props3$featureF === void 0 ? {
                  launchCommSettingsFollowAction: false
                } : _this$props3$featureF;
                _context.next = 4;
                return (0, _modals.shouldShowGDPRModal)(isGDPRCountry, userId, featureFlags.launchCommSettingsFollowAction);

              case 4:
                shouldShowModal = _context.sent;

                if (shouldShowModal) {
                  _this.props.trackGAEvent(_this._getGAEventParamsFor('gdprModal', organizerId));

                  _this._renderGDPRModal();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "_shouldFollowOrganizerFromCookie", function (organizerId) {
      var _this$props4 = _this.props,
          isAuthenticated = _this$props4.isAuthenticated,
          getFollowState = _this$props4.getFollowState;

      var _getFollowState3 = getFollowState(),
          organizerData = _getFollowState3.organizerData;

      var organizerIdFromCookie = (0, _modals.getOrganizerIdFromCookie)();

      if (isAuthenticated && organizerData[organizerId] && !organizerData[organizerId].followedByYou && organizerIdFromCookie && organizerIdFromCookie === organizerData[organizerId].id) {
        _this._followOrganizer(organizerId);

        _this._clearOrganizerCookie();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_clearOrganizerCookie", function () {
      (0, _modals.expireOrganizerCookie)();
    });

    _defineProperty(_assertThisInitialized(_this), "_trackFollowEvent", function (organizerId) {
      _this.props.trackGAEvent(_this._getGAEventParamsFor('follow', organizerId));

      (0, _performanceMonitor.setCustomData)(_constants.FOLLOW_DONE_CUSTOM_METRIC_DATA, 1);
      (0, _janus.logCheckpointViaAjax)('follow_organizer');
    });

    _defineProperty(_assertThisInitialized(_this), "_trackFollowAttempt", function (organizerId) {
      _this.props.trackGAEvent(_this._getGAEventParamsFor('followAttempt', organizerId));
    });

    _defineProperty(_assertThisInitialized(_this), "_trackUnfollowEvent", function (organizerId) {
      _this.props.trackGAEvent(_this._getGAEventParamsFor('unfollow', organizerId));
    });

    _defineProperty(_assertThisInitialized(_this), "_getGAEventParamsFor", function (action, organizerId) {
      var _this$props5 = _this.props,
          gaCategory = _this$props5.gaCategory,
          gaActionSuffix = _this$props5.gaActionSuffix;
      var organizerData = _this.state.organizerData;
      var actionName = _constants.actionToGAActionMap[action];
      var dimensions = gaActionSuffix ? {
        dimension4: gaActionSuffix
      } : {};
      return {
        action: actionName,
        category: gaCategory,
        label: (0, _get.default)(organizerData, [organizerId, 'name']),
        dimensions: dimensions
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_updateFollowState", function (organizerId, _ref5) {
      var followedByYou = _ref5.followedByYou;
      var _this$props6 = _this.props,
          setFollowState = _this$props6.setFollowState,
          getFollowState = _this$props6.getFollowState;
      var currentState = getFollowState();

      if (_this._isMounted) {
        setFollowState(_objectSpread(_objectSpread({}, currentState), {}, {
          organizerData: _objectSpread(_objectSpread({}, currentState.organizerData), {}, _defineProperty({}, organizerId, _objectSpread(_objectSpread({}, currentState.organizerData[organizerId]), {}, {
            followedByYou: followedByYou
          })))
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderGDPRModal", function () {
      var _this$props7 = _this.props,
          trackGAEvent = _this$props7.trackGAEvent,
          getFollowState = _this$props7.getFollowState,
          setFollowState = _this$props7.setFollowState,
          onChange = _this$props7.onChange,
          userId = _this$props7.userId,
          gaCategory = _this$props7.gaCategory,
          _this$props7$featureF = _this$props7.featureFlags,
          featureFlags = _this$props7$featureF === void 0 ? {
        launchCommSettingsFollowAction: false
      } : _this$props7$featureF;
      (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(_FollowGDPRModal.default, {
        userId: userId,
        trackGAEvent: trackGAEvent,
        gaCategory: gaCategory,
        getSharedState: getFollowState,
        setSharedState: setFollowState,
        onChangeSharedState: onChange,
        launchCommSettingsFollowAction: featureFlags.launchCommSettingsFollowAction
      }), (0, _modals.createGDPRContainer)(), function () {
        setFollowState(_objectSpread(_objectSpread({}, getFollowState()), {}, {
          gdprModalShown: true
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_renderLoginModal", function (organizerId) {
      var _this$props8 = _this.props,
          getFollowState = _this$props8.getFollowState,
          setFollowState = _this$props8.setFollowState,
          trackGAEvent = _this$props8.trackGAEvent,
          onChange = _this$props8.onChange,
          loginOptions = _this$props8.loginOptions;

      var _getFollowState4 = getFollowState(),
          organizerData = _getFollowState4.organizerData;

      var organizer = (0, _get.default)(organizerData, [organizerId]);

      if (organizer) {
        (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(_FollowLoginModal.default, {
          organizerId: organizerId,
          organizerName: (0, _get.default)(organizer, 'name'),
          trackGAEvent: trackGAEvent,
          organizerProfilePicture: (0, _get.default)(organizer, 'profilePicture', ''),
          getSharedState: getFollowState,
          setSharedState: setFollowState,
          onChangeSharedState: onChange,
          referrer: loginOptions.referrer,
          shouldOpenNewTab: loginOptions.shouldOpenNewTab
        }), (0, _modals.createLoginModalContainer)(), function () {
          setFollowState(_objectSpread(_objectSpread({}, getFollowState()), {}, {
            loginModalShown: true
          }));
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderNotification", function (organizerId) {
      var errorActionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$props9 = _this.props,
          getFollowState = _this$props9.getFollowState,
          setFollowState = _this$props9.setFollowState,
          onChange = _this$props9.onChange;
      (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(_FollowNotification.default, {
        organizerId: organizerId,
        getSharedState: getFollowState,
        setSharedState: setFollowState,
        onChangeSharedState: onChange,
        errorActionType: errorActionType
      }), (0, _modals.createFollowNotificationContainer)(), function () {
        setFollowState(_objectSpread(_objectSpread({}, getFollowState()), {}, {
          followNotificationShown: true
        }));
      });
    });

    var newState = (0, _state.computeMergedState)(props);

    _setFollowState(_objectSpread(_objectSpread({}, _getFollowState()), newState));

    _this.state = newState;
    return _this;
  }

  _createClass(FollowMarionette, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this.props.onChange(this._handleFollowStateChange);

      this._hydrateOrganizerData();

      (0, _performanceMonitor.setMark)(_constants.FOLLOW_READY_CUSTOM_METRIC_MARK);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props10 = this.props,
          style = _this$props10.style,
          listStyle = _this$props10.listStyle,
          size = _this$props10.size;
      var _this$state = this.state,
          organizerData = _this$state.organizerData,
          organizers = _this$state.organizers;
      var followComponent = null;

      if (organizers.length > 1) {
        followComponent = /*#__PURE__*/_react.default.createElement("ul", {
          className: "follow-list follow-list--".concat(listStyle)
        }, organizers.map(function (organizerId) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: (0, _get.default)(organizerData, [organizerId, 'id']),
            className: "follow-list__item"
          }, /*#__PURE__*/_react.default.createElement(_FollowCard.default, {
            organizerId: organizerId,
            organizerName: (0, _get.default)(organizerData, [organizerId, 'name']),
            style: listStyle,
            isFollowing: (0, _get.default)(organizerData, [organizerId, 'followedByYou']),
            organizerProfileUrl: (0, _get.default)(organizerData, [organizerId, 'url']),
            onFollow: _this2._handleOnFollowOrganizer.bind(null, organizerId),
            onUnFollow: _this2._handleOnUnfollowOrganizer.bind(null, organizerId),
            isClosable: false,
            isHiddenWhenFollowed: false,
            numUpcomingEvents: (0, _get.default)(organizerData, [organizerId, 'numUpcomingEvents']),
            numFollowers: (0, _get.default)(organizerData, [organizerId, 'numFollowers']),
            imageUrl: (0, _get.default)(organizerData, [organizerId, 'imageUrl']),
            customDataPoint: (0, _get.default)(organizerData, [organizerId, 'customDataPoint']),
            size: size
          }));
        }));
      } else {
        followComponent = /*#__PURE__*/_react.default.createElement(_FollowButton.default, {
          onFollow: this._handleOnFollowOrganizer.bind(null, organizers[0]),
          onUnFollow: this._handleOnUnfollowOrganizer.bind(null, organizers[0]),
          organizerName: (0, _get.default)(organizerData, [organizers[0], 'name']),
          style: style,
          size: size,
          isFollowing: (0, _get.default)(organizerData, [organizers[0], 'followedByYou'])
        });
      }

      return followComponent;
    }
  }]);

  return FollowMarionette;
}(_react.Component);

exports.default = FollowMarionette;

_defineProperty(FollowMarionette, "propTypes", {
  isGDPRCountry: _propTypes.default.bool.isRequired,
  organizers: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  isAuthenticated: _propTypes.default.bool.isRequired,
  gaCategory: _propTypes.default.string.isRequired,
  trackGAEvent: _propTypes.default.func.isRequired,
  getFollowState: _propTypes.default.func.isRequired,
  setFollowState: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  organizerData: _propTypes.default.objectOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired,
    followedByYou: _propTypes.default.bool,
    profilePicture: _propTypes.default.string,
    numUpcomingEvents: _propTypes.default.number,
    numFollowers: _propTypes.default.number,
    customDataPoint: _propTypes.default.string
  })),
  loginOptions: _propTypes.default.shape({
    referrer: _propTypes.default.string,
    shouldOpenNewTab: _propTypes.default.bool,
    shouldUseSigninConfirmationRedirect: _propTypes.default.bool
  }),
  userId: _propTypes.default.string,
  gaActionSuffix: _propTypes.default.string,
  style: _propTypes.default.oneOf(_constants.FOLLOW_BUTTON_STYLES),
  size: _propTypes.default.oneOf(_constants.FOLLOW_BUTTON_SIZES),
  listStyle: _propTypes.default.oneOf(_constants.FOLLOW_LIST_STYLES),
  cardSize: _propTypes.default.oneOf(_constants.CARD_SIZES),
  featureFlags: _propTypes.default.object
});

_defineProperty(FollowMarionette, "defaultProps", {
  style: 'standard',
  size: 'standard',
  listStyle: 'grid',
  loginOptions: {}
});